import './styles.scss';

export default {
  name: 'ChangePassword',

  data() {
    return {
      email: this.$route.query.email,
      securityQuestionId: this.$route.query.securityQuestionId,
      password: '',
      confirmPassword: '',
      allowLogin: true
    }
  },


  methods: {
    async authenticate() {
      if (this.password && this.confirmPassword && (this.password === this.confirmPassword)) {
        if (this.$store.state.online_status) {

          this.loginAlert = await this.$ionic.loadingController.create({
            spinner: 'lines',
            animated: true,
            message: '',
            translucent: false,
          });

          this.loginAlert.present();

          const data = {
            email: this.email,
            password: this.password,
            confirm_password: this.confirmPassword
          };

          this.$store
            .dispatch("resetPassword", data)
            .then((response) => {
              this.loginAlert.dismiss();
              this.showSuccessPopup();
            })
            .catch((error) => {
              this.loginAlert.dismiss();
              this.$ionic.alertController
                .create({
                  message: error,
                  buttons: ["OK"],
                })
                .then((a) => a.present());
            });
        } else {
          this.$ionic.alertController
            .create({
              message: "Please establish and internet connection and try again.",
              buttons: ["OK"],
            })
            .then((a) => a.present());
        }
      } else {
        let message = 'Please enter ';

        if (!this.password && !this.confirmPassword) {
          message += 'password and confirmPassword.';
        } else if (!this.password) {
          message += 'password.';
        } else if (!this.confirmPassword) {
          message += 'confirmPassword';
        } else if (this.password !== this.confirmPassword) {
          message = "Password and Confirm Password don't match."
        }

        this.$ionic.alertController.create({
          header: 'Error',
          message: message,
          buttons: ['OK'],
        }).then(a => a.present());
      }
    },

    showSuccessPopup() {
      this.$ionic.alertController.create({
        header: 'Success',
        message: 'Your password has been reset successfully.',
        buttons: [{
          text: 'OK',
          handler: () => {
            this.$router.go(-3);
          }
        }]
      }).then(alert => {
        alert.present();
      });
    }
  }
};